module.exports = __webpack_public_path__ + "img/Facebook Icon - white.71f3c7b0.svg";